import { FaWhatsappSquare } from "react-icons/fa";
import { SiGmail } from "react-icons/si";

export function Support() {
    return (
        <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-10 text-slate-800">

            {/* Lien chaine whatsapp */}
            <div className="bg-white rounded-lg shadow-md p-4 md:p-6 flex-1 flex flex-col justify-between items-center text-center">
                <div className="flex flex-col md:flex-row items-center gap-4 md:gap-10">
                    <div>
                        <h2 className="text-lg md:text-xl font-bold">Chaîne WhatsApp</h2>
                        <p className="text-sm md:text-base">Retrouvez toutes les actualités de Capitalya sur la chaîne officielle</p>
                    </div>
                    <div className="animate-flotter">
                        <FaWhatsappSquare className="text-[#25D366] size-16 md:size-20" />
                    </div>
                </div>
                <button className="mt-4 bg-slate-800 text-white py-2 px-4 w-full md:w-40 rounded-md" onClick={() =>
                    window.open(
                        "https://whatsapp.com/channel/0029Vb73UkW1t90axzBcT62y",
                        "_blank"
                    )
                }>
                    Cliquer-ici
                </button>
            </div>

            {/* Support Client */}
            <div className="bg-white rounded-lg shadow-md p-4 md:p-6 flex-1 flex flex-col justify-between items-center text-center">
                <div className="flex flex-col md:flex-row items-center gap-4 md:gap-10">
                    <div>
                        <h2 className="text-lg md:text-xl font-bold">Support Client</h2>
                        <p className="text-sm md:text-base">Écrivez-nous sur WhatsApp</p>
                    </div>
                    <div className="animate-flotter">
                        <FaWhatsappSquare className="text-[#2ab384] size-16 md:size-20" />
                    </div>
                </div>
                <button className="mt-4 bg-slate-800 text-white py-2 px-4 w-full md:w-40 rounded-md" onClick={() =>
                    window.open(
                        "https://wa.me/22890974255?text=Bonjour",
                        "_blank"
                    )
                }>
                    Cliquer-ici
                </button>
            </div>

            {/* Administrateur */}
            <div className="bg-white rounded-lg shadow-md p-4 md:p-6 flex-1 flex flex-col justify-between items-center text-center">
                <div className="flex flex-col md:flex-row items-center gap-4 md:gap-10">
                    <div>
                        <h2 className="text-lg md:text-xl font-bold">Administrateur</h2>
                        <p className="text-sm md:text-base">Adressez vos problèmes techniques</p>
                    </div>
                    <div className="animate-flotter">
                        <SiGmail className="text-red-800 size-16 md:size-20" />
                    </div>
                </div>
                <button className="mt-4 bg-slate-800 text-white py-2 px-4 w-full md:w-40 rounded-md" onClick={() => window.open("mailto:capitalyanet@gmail.com?subject=Support&body=Bonjour,")}>
                    Cliquer-ici
                </button>
            </div>

        </div>
    );
}
